import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./de.json";
import en from "./en.json";

// German-only product: force "de" so the UI never auto-switches to the
// (partial) English bundle based on browser locale — that caused the de/en mix.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    lng: "de",
    fallbackLng: "de",
    supportedLngs: ["de"],
    interpolation: { escapeValue: false },
  });

export default i18n;
